import { createPricesFilterClickEvent } from '@/domain/prices/analytics/index';
import type { Option } from '@/domain/prices/filters/types';
import { useIntl } from '../../../intl';
import MultiSelectPricesFilter, { mapLocalSelectionToGA4Result } from './BaseFilter/MultiSelectPricesFilter';
import { usePricesStore } from '@/infrastructure/prices/usePricesStore';

export function RoomTypeFilter() {
  const intl = useIntl();
  const { filterSelection } = usePricesStore();

  if (filterSelection.Participants && filterSelection.Participants?.length > 1) {
    return null;
  }

  return (
    <MultiSelectPricesFilter
      type="RoomType"
      label={intl.formatMessage({ id: 'prices_filters_roomtype_label' })}
      placeholder={intl.formatMessage({ id: 'prices_filters_roomtype_placeholder' })}
      confirmButton={intl.formatMessage({ id: 'prices_filters_roomtype_confirm_button' })}
      icon="IconBed"
      analyticsEventBuilder={(selection: string | string[] | undefined, options: Option[]) => {
        return createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'roomType',
          result: mapLocalSelectionToGA4Result(selection, options),
        });
      }}
    />
  );
}
